import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Cell,
  CartesianGrid,
} from "recharts";

interface SourceDistributionChartProps {
  data: Array<{ source: string; count: number }>;
}

const SOURCE_COLORS: Record<string, string> = {
  equip_scout: "hsl(221 83% 53%)",
  city: "hsl(142 71% 45%)",
  external_import: "hsl(25 95% 53%)",
};

function formatSource(str: string): string {
  return str
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function SourceDistributionChart({ data }: SourceDistributionChartProps) {
  if (!data.length) {
    return (
      <div className="flex h-[300px] items-center justify-center text-sm text-muted-foreground">
        No data yet
      </div>
    );
  }

  const formatted = data.map((d) => ({
    ...d,
    name: formatSource(d.source),
  }));

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={formatted} layout="vertical">
        <CartesianGrid strokeDasharray="3 3" className="stroke-border" />
        <XAxis type="number" tick={{ fontSize: 12 }} />
        <YAxis
          type="category"
          dataKey="name"
          tick={{ fontSize: 12 }}
          width={120}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: "hsl(var(--popover))",
            border: "1px solid hsl(var(--border))",
            borderRadius: "6px",
            color: "hsl(var(--popover-foreground))",
          }}
        />
        <Bar dataKey="count" radius={[0, 4, 4, 0]}>
          {formatted.map((entry) => (
            <Cell
              key={entry.name}
              fill={
                SOURCE_COLORS[entry.source] ?? "hsl(0 0% 70%)"
              }
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}
